import React from 'react'
import ReactDOM from 'react-dom/client'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact, { BugsnagPluginReactResult } from '@bugsnag/plugin-react'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from 'styled-components'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { setConfig, type AppConfig } from './config/runtime'

const theme = createTheme({
  palette: {
    primary: {
      main: '#225099',
    },
  },
})

function renderPartialApp(config: AppConfig) {
  if (!config.bugsnag.enabled) {
    return <App />
  }

  Bugsnag.start({
    apiKey: config.bugsnag.apiKey,
    plugins: [new BugsnagPluginReact(React)],
  })
  const plugin = Bugsnag.getPlugin('react') as BugsnagPluginReactResult
  const ErrorBoundary = plugin.createErrorBoundary()

  return ErrorBoundary ? (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  ) : (
    <App />
  )
}

async function bootstrap() {
  const res = await fetch('/config.json')
  if (!res.ok) throw new Error(`Failed to load config.json: ${res.status}`)
  const config: AppConfig = await res.json()
  setConfig(config)

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {renderPartialApp(config)}
      </ThemeProvider>
    </MuiThemeProvider>
  )

  serviceWorker.unregister()
}

bootstrap().catch((err) => {
  console.error('Fatal: could not load app config', err)
  const el = document.getElementById('root')
  if (el) el.textContent = 'Failed to load application configuration.'
})
